/**
 * The hour on the world: dusk, dawn and the night with its pools of light (render/lighting.ts), or
 * indoors the room's light and shade (interior.ts). With lights and shadows off (settings): plain
 * daylight, the night and a room's darkness not drawn.
 */
import { drawNight, lightingOn } from '../lighting';
import { heightOf, hidden } from '../drawKit';
import { registerRenderPass } from './registry';

registerRenderPass({
  id: 'lighting',
  layer: 'world',
  order: 400,
  draw(f) {
    if (!lightingOn()) return;
    if (f.scene) f.indoor.drawLight(f.g, f.scene, f.ox, f.oy, f.world.time, [f.player[0], f.player[1]]);
    else
      drawNight({
        g: f.g,
        gpu: f.gpu,
        world: f.world,
        iso: f.iso,
        ox: f.ox,
        oy: f.oy,
        W: f.W,
        H: f.H,
        heightOf: (e) => heightOf(f.sprites, e),
        groundOf: (e) => f.effects.anim(e.id).elev,
        hidden,
      });
  },
});
